import axios from "axios";

const api = axios.create({
  baseURL: "https://inscripcion-comitesapi.ccpll.org/api",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  }
});

// Revisar si ya hay un token guardado
const token = localStorage.getItem("token");
if (token) {
  api.defaults.headers.common["Authorization"] = "Bearer " + token;
}

export default api;
